import { gql } from '@apollo/client'

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    userLogin(input: { email: $email, password: $password }) {
      user {
        id
        email
      }
      token
      errors
    }
  }
`

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    userLogout {
      success
      errors
    }
  }
` 